import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../services';
import {map, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlockAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isAuthenticated.pipe(take(1), map( isAuth => {
      return !isAuth;
    }));
  }
}
